import { createReducer } from '@src/redux/helpers/createReducer';
import {
  SET_STEPPER,
  SET_STEP,
  SET_CURRENT_STEP,
  SET_COMPLETE_STEP,
  RESET_STEP,
} from './constants';

const initialState = { step: [], currentStep: 1 };

export const onStepperReducer = createReducer(initialState, {
  [SET_STEPPER]: (state, action) => {
    return {
      ...state,
      step: action.payload.save ? action.payload.data : state.step,
    };
  },
  [SET_STEP]: (state, action) => {
    const stepToUpdate = action.payload.data.step;
    const newStepper = state.step.map((step) => {
      if (step.step === stepToUpdate) {
        return action.payload.data;
      }
      return step;
    });
    return {
      ...state,
      step: newStepper,
    };
  },
  [SET_CURRENT_STEP]: (state, action) => {
    return {
      ...state,
      currentStep: action.payload,
    };
  },
  [SET_COMPLETE_STEP]: (state, action) => {
    const newStepper = state.step.map((step) => {
      if (step.step === action.payload) {
        return {
          ...step,
          complete: true,
        };
      }
      return step;
    });

    return {
      ...state,
      step: newStepper,
    };
  },
  [RESET_STEP]: (state) => {
    return {
      step: [],
      currentStep: 1,
    };
  },
});
